
import { ref, computed } from 'vue';
import { useCrmFormFile } from './CrmFormFile';
import { CrmFormFile } from './CrmFormFile';
import { injectEnv } from "@fd/Environment";

export function useBaseFile(props, uploadedFile, uploadedAllFiles, endpoint, emit) {
	
	const UPLOAD_TIMEOUT=500;
	const CLASSEVENTS = ['dragenter', 'dragover', 'dragleave', 'drop'];
	
	const files = ref<UploadableFile[]>([]);
	const uploading = ref(false);
	const uploadingFileDone = ref(false);
	const uploadingFile = ref<UploadableFile>(null);
		
	const active = ref(false);
	const inActiveTimeout = ref(null);
	
	const sequence = ref(0);
	
	const errorMessage = ref("");
	const env = injectEnv();
	const bundleErrorType: string = env.msg("baseFile.errorUnsupportedType");
	const dragError: string = env.msg("baseFile.errorTransfer"); 
	
	const { attFileToFile, urlToFile, asPromise } = useCrmFormFile();
	
	const sumUploadingFiles = computed(() => {
		return files.value.length;
	});
	
	const dropClass = computed(() => {
		return active.value?" dz-active ":"";
	});
	
	const isError = computed(() => {
		return  errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});
	
	const endpointUrl = computed<string>(() => {
		return endpoint() || props.endpoint;
	});
	
	const uploadRestApi = computed(() => {
		let url = endpointUrl.value;
		url = env.net.urlParam(url, "sequence", sequence.value);
		console.log("uploadURL:"+url);
		return url;
	});
	
	function setActive(): void {
		active.value = true;
		clearTimeout(inActiveTimeout.value) // clear the timeout
	};
	
	function setInactive(): void {
		inActiveTimeout.value = setTimeout(() => {
			active.value = false;
		}, 200);
	}
	
	function toUploadableFiles(newFiles: File[]) : UploadableFile[]
	{
		return  [...newFiles].map((file) => new UploadableFile(file))
				.filter((file) => !fileExists(file) && isValidFile(file, filterToArray(props.typeFilter)));
	}
	
	function filterToArray(typeFilter: string): string[] {
		return typeFilter?typeFilter.split(','):[];
	}
	
	function isValidFile(file: UploadableFile, typeFilterArray: string[]): boolean {
		if (typeFilterArray && typeFilterArray.length>0) {
			let result = typeFilterArray.find(mimeType => file.getType().includes(mimeType));
			if (result === undefined) {
				errorMessage.value=bundleErrorType;
				return false;
			}
		}
		return true; //typeFilter is empty or result!=undefined
	}
	
	function fileExists(uploadingFile: UploadableFile): boolean {
		return files.value.some((file) => file.id === uploadingFile.id);
	}
	
	function processUploadAllResult(): void {
		if (props.type!=="file-entry") {
			uploadingFile.value=null;
		}
		files.value=[];
		uploading.value=false;
		console.log("FD editor component - all done! props type:"+props.type);
	}
	
	function uploadingFileName(file: UploadableFile, index: number): string {
		if (props.type!=="file-entry") {
			return uploadingFileNameTitle(file.getName(), index, sumUploadingFiles.value);
		}
		else {
			return file.getName();
		}
	}
	
	function uploadingFileNameTitle(fileName: string, index: number, sum: number) {
		return fileName+" ("+index+"/"+sum+")";
	}
	
	function uploadFile(file: UploadableFile, index: number): Promise<unknown> {
		// set up the request data
		let formData = new FormData();
		formData.append('file', file.file);
		uploading.value=true;
		uploadingFileDone.value=false,
		file.setUploadingTitle(uploadingFileName(file, index));
		uploadingFile.value=file;

		return env.net.fetch(uploadRestApi.value, 'POST', formData)
			.then(response => response.json())
			.then(data => {
				console.log("uploaded file:"+file.getName());
				uploadedFile(data);
				sequence.value +=10; //for uploading file with sequence
				return new Promise(resolve => setTimeout(resolve, UPLOAD_TIMEOUT));
			})
			.catch((error) => {
				console.log("error refresh data:"+JSON.stringify(error));
				errorMessage.value=JSON.stringify(error);
			});
	}
	
	function removeFromZone(id: string): Promise<boolean> {
		let deleteRestApi = endpointUrl.value+"/"+id;
		console.log("removing from url:"+deleteRestApi);
		return env.net.fetch(deleteRestApi,'DELETE')
			.then(response => { return true; })
			.catch((error) => {
				console.log("error deleting file:"+JSON.stringify(error));
				errorMessage.value=JSON.stringify(error);
				return false;
			});
	}
	
	function uploadFilesSerial(): void {
		  var result: Promise<unknown> = Promise.resolve();
		  var index = 1;
		  files.value.forEach(file => {
			result = result.then(() => uploadFile(file, index++));
		  });
		  
		  result = result
				.then(() => {
					uploadingFileDone.value=true;
					return new Promise(resolve => setTimeout(resolve, UPLOAD_TIMEOUT));
				})	
				.then(() => {
					processUploadAllResult();
					uploadedAllFiles();
				 });
	}
	
	//LOAD
	function loadZone(): Promise<CrmFormFile[]> {
		return env.net.fetch(endpointUrl.value)
			.then(response => response.json())
			.then(data => {
				//console.log("Loaded data:"+JSON.stringify(data));
				return data;
			})
			.catch((error) => {
				console.log("error loading table:"+error);
				errorMessage.value = error;
				return [];
			});
	}
	
	function loadFile(id: String): Promise<CrmFormFile> {
		console.log("url:"+"api/files/crmFile/"+id);
		return env.net.fetch("api/files/crmFile/"+id)
			.then(response => response.json())
			.then(data => {
				//console.log("Loaded data:"+JSON.stringify(data));
				return createEmptyFile(data.fileName,data.contentType,data.fileName);
			})
			.catch((error) => {
				console.log("error loading crmFile:"+error);
				errorMessage.value = error;
				return null;
			});
	}
	
	//DRAG
	function onDrop(e): void {
		console.log("file drag&drop");
		setInactive();

		let dragFiles = e.dataTransfer.files; //drag&drop
		console.log("drag files:"+dragFiles.length);
		if (dragFiles !== null && dragFiles !== undefined && dragFiles.length>0) {
			addFiles([...dragFiles]);
		}
		else {//error console log
			let data = e.dataTransfer.getData("text");
			if (data && data.startsWith("http")) {
				let file = urlToFile(data);
				addFiles([file]);
			}
			else {
				if (dragFiles !== null && dragFiles !== undefined) console.log("Undefined e.dataTransfer.files");
				else if (dragFiles.length===0) console.log("e.dataTransfer.files lenght is 0 - empty?");
				errorMessage.value=dragError;
			}
		}
	};
	
	//DISC
	function onInputChange(e): void {
		console.log("file input");
		addFiles(e.target.files);
		e.target.value = null;
	}
	
	//CLIPBOARD
	function onClipboard(): void {
		console.log("on clipboard");
		navigator.permissions.query({name: "clipboard-read"}).then((permission)=>{
			if (permission.state === "granted" || permission.state === "prompt") {
				navigator.clipboard.read()
					.then(clipboardContents=> {
						var promises = [];
						for (const item of clipboardContents) {
							promises.push(asPromise(item));
						}
						Promise.all(promises).then((files) => {
							addFiles(files);
						});
					})
					.catch((error) => {
						console.log("error reading clipboard:"+JSON.stringify(error));
						errorMessage.value=JSON.stringify(error);
					});
			}
			else {
				console.log("Browser clipboard disabled");
				errorMessage.value="Not allowed to read clipboard.";
			}
		})
		.catch((error) => {
			console.log("error check permissions:"+JSON.stringify(error));
			errorMessage.value="Problem with browser support:"+error.message;
		});
	}
	
	function addFiles(newFiles: File[]): void {
		console.log("Files to upload:"+newFiles.length);
		errorMessage.value="";
		files.value = files.value.concat(toUploadableFiles(newFiles)); //join arrays
		uploadFilesSerial();
	}
	
	//DOCUMENTS
	function onCrmFile(id: number, name: string, mime: string): void {
		let newFiles: File[] = [];
		newFiles.push(attFileToFile(id,name));
		
		addFiles(newFiles);
	}

	function createEmptyFile(fileName: string, fileType: string, uploadingTitle: string): UploadableFile
	{
		const uFile = new UploadableFile(new File([],fileName, {type: fileType}));
		uFile.setUploadingTitle(uploadingTitle);
		return uFile;
	}
	
	return  { CLASSEVENTS, dropClass, errorMessage, isError, 
				uploadingFile, uploading, uploadingFileDone,
				active, setActive, setInactive, 
				onDrop, onInputChange, onClipboard, onCrmFile,
				loadZone, loadFile, removeFromZone };
}

class UploadableFile {
	file: File;
	id: string;
	uploadingTitle: string;
	attFileContentType: string;
	
    constructor(file: File) {
        this.file = file;
        this.id = `${file.name}`;
		this.uploadingTitle="";
    }
	
	getName(): string {
		return this.file.name;
	}
	
	setUploadingTitle(uploadingTitle: string): void {
		this.uploadingTitle=uploadingTitle;
	}
	
	getType(): string {
		return this.file.type;
	}
	/*Content type of attFile paired with this*/
	setAttFileContentType(contentType: string): void {
		this.attFileContentType=contentType;
	}
	
}
